import React, { useState } from 'react';
import { mapHeight, mapWidth } from "../config/defaults";
import { isSafari } from "../helpers/common";
import mapBackgroundFull from '../assets/images/map-background-full-sized.jpg';
import mapBackgroundPreload from '../assets/images/map-background-preload.jpg';

const MapBackground = ({ isFromApp }) => {
	const [isBigImageLoaded, setBigImageLoaded] = useState(false);
	const onLoadNotSupported = isSafari || isFromApp;

	return (
		<g>
			<image
				onLoad={() => setBigImageLoaded(true)}
				x="9" y="0"
				width={mapWidth}
				height={mapHeight}
				viewBox={`0 0 ${mapWidth} ${mapHeight}`}
				xlinkHref={mapBackgroundFull}
				onMouseDown={event => {if (event.preventDefault) event.preventDefault()}}
				style={{ opacity: isBigImageLoaded || onLoadNotSupported ? 1 : 0, transition: 'all 0.5s linear' }}
				className="image-background"
			/>

			{(!isBigImageLoaded && !onLoadNotSupported) && (
				<image
					x="0"
					y="0"
					width={mapWidth}
					height={mapHeight}
					viewBox={`0 0 ${mapWidth} ${mapHeight}`}
					xlinkHref={mapBackgroundPreload}
					onMouseDown={event => {if (event.preventDefault) event.preventDefault()}}
					style={{ position: 'absolute', transition: 'all 0.5s linear' }}
				/>
			)}
		</g>
	)
};

export default MapBackground;
